/* Visibility only. Buying, inventory and payments stay with native Shopify forms. */
(() => {
  function initialize() {
    const bar = document.querySelector('[data-cj-purchase-bar]');
    const button = document.querySelector('input#addToCart');
    if (!bar || !button || !('IntersectionObserver' in window)) return;
    if (bar.dataset.cjInitialized) return;
    bar.dataset.cjInitialized = 'true';
    const observer = new IntersectionObserver(entries => {
      bar.hidden = entries[0].isIntersecting;
    }, { threshold: 0.1 });
    observer.observe(button);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
